import type { Type } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

import { ELEMENT_MAPPING } from '../../../integrations/elements';
import type { DynamicCustomInputConfig } from '../../types';
import { DynamicFormInput } from '../dynamic-form/dynamic-form-input/dynamic-form-input';

export class CustomInput extends DynamicFormInput<DynamicCustomInputConfig> {}

@Component({
  selector: 'rti-custom-input',
  template: '<ng-template #container />',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class CustomInputComponent {
  @Input() public input: CustomInput;

  @ViewChild('container', { read: ViewContainerRef, static: true })
  private container: ViewContainerRef;

  public ngOnInit(): void {
    const componentImport = this.findComponentClass();
    if (componentImport) {
      this.createCustomComponent(componentImport);
    } else {
      console.warn(
        `No custom component for ${this.input.config.component}. Check integrations ELEMENT_MAPPING`,
      );
    }
  }

  private findComponentClass(): undefined | (() => Promise<Type<any>>) {
    const mapping = ELEMENT_MAPPING.find(([key]) => key === this.input.config.component);
    return mapping && mapping[1];
  }

  private async createCustomComponent(componentImport: () => Promise<Type<any>>) {
    this.container.clear();

    const componentClass = await componentImport();
    const componentRef = this.container.createComponent(componentClass);
    if (componentRef.instance.initState) {
      componentRef.instance.initState(this.input.config.componentData, this.input.control);
    } else {
      Object.assign(componentRef.instance, this.input.config.componentData);
      componentRef.instance.formControl = this.input.control;
    }
    componentRef.changeDetectorRef.detectChanges();
  }
}
